import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { User } from '../models/user.model';
import { AuthStore } from '../state/auth/auth.store';

/**
 * Component that provides the basic properties needed for pages.
 */
@Component({
  selector: 'app-page',
  template: ``,
  styles: [],
  standalone: true,
})
export class PageComponent implements OnInit, OnDestroy {
  isLoading = false;

  currentUser: User = new User();
  currentUserSub: Subscription;

  protected authStore = inject(AuthStore);

  constructor() {
    this.startLoading();
    this.currentUserSub = toObservable(this.authStore.user).pipe(
      filter((user): user is User => user !== null)
    ).subscribe((user: User) => {
      this.currentUser = user;
    });
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.currentUserSub.unsubscribe();
  }

  startLoading(): void {
    this.isLoading = true;
  }

  stopLoading(): void {
    this.isLoading = false;
  }

  get isAdmin(): boolean {
    return this.currentUser.isAdmin;
  }
}
